// import { ILoginData } from "./../../interfaces/auth.interface";
// import { IHttp, IHttpResponse } from "./../../interfaces/http.interface";
import { AxiosResponse } from "axios";
import axiosInstance from "../../axios/axios";
import * as authActions from "./authActions";
import { AuthResultDto } from "./dtos/AuthResultDto";
import QueryResponse from "./shared models/QueryResponse";
import { requestHeader } from "./sharedUtils";

export const checkLogin = (isAuth: boolean) => {
  // some aync logic
  return {
    type: authActions.CHECK_TOKEN,
    isAuth: isAuth,
  };
};

export const login = async (data: any): Promise<[any, any]> => {
  try {
    const response = await axiosInstance.post("/admin/authenticate", data);
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const customerLogin = async (
  data: any
): Promise<[QueryResponse<AuthResultDto> | null, any]> => {
  try {
    const response = await axiosInstance.post<QueryResponse<AuthResultDto>>(
      "/customer/authenticate",
      data
    );
    return [response?.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const signup = async (data: any) => {
  try {
    const response = await axiosInstance.post("/customer/register", data);
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const checkCustomerExist = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      "/customer/checkcustomerifexists",
      data
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const resetPassword = async (data: any) => {
  try {
    const response = await axiosInstance.post("/auth/reset-password", data);
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const confirmUserEmail = async (data: any) => {
  try {
    const response = await axiosInstance.post("/auth/confirm-email", data);
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const forgotPassword = async (data: any) => {
  try {
    const response = await axiosInstance.post("/auth/forgot-password", data);
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const resendLink = async (email: any) => {
  try {
    const response = await axiosInstance.get(
      `/auth/resend-verification-email/${email}`
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const changePassword = async (data: any, token: any) => {
  try {
    const response = await axiosInstance.post("/auth/change-password", data, {
      headers: {
        Authorization: `Bearer ${token}`, //the token is a variable which holds the token
      },
    });
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const startImpersonation = async (
  userToImpersonate: string
): Promise<[QueryResponse<AuthResultDto> | null, unknown]> => {
  try {
    const response = await axiosInstance.get<QueryResponse<AuthResultDto>>(
      `/auth/startImpersonation/${userToImpersonate}`,
      requestHeader
    );
    return [response?.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const endImpersonation = async (): Promise<
  [QueryResponse<AuthResultDto> | null, unknown]
> => {
  try {
    const response = await axiosInstance.get<QueryResponse<AuthResultDto>>(
      `/auth/endImpersonation`,
      requestHeader
    );
    return [response?.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const checkIfImpersonating = async (): Promise<
  [AxiosResponse<boolean> | null, unknown]
> => {
  try {
    const response = await axiosInstance.get<boolean>(
      `/auth/checkIfImpersonating`,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};
